export function getNoteCreatorName(note) {
  const maker = note?.note_maker_user_id

  if (!maker || typeof maker !== 'object') {
    return 'System'
  }

  const firstName = (maker.first_name || '').trim()
  const lastName = (maker.last_name || '').trim()
  const type = (maker.type || '').trim().toLowerCase()

  if (type === 'website' || type === 'system' || firstName.toLowerCase() === 'website' || firstName.toLowerCase() === 'system') {
    return 'System'
  }

  const fullName = `${firstName} ${lastName}`.trim()
  return fullName || 'System'
}
